import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilsService } from './../../services/utils.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ UtilsService ]
})
export class NotificationsComponent implements OnInit {

  constructor(
  	public dialogRef: MatDialogRef<NotificationsComponent>,
  	@Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
     private _utils: UtilsService
  ) {}

  ngOnInit() {
    this.data.message = this.sanitizer.bypassSecurityTrustHtml(this.data.message);
  }

  submit(value?: string) {
  	this.dialogRef.close(value);
  }

  redirectHabilitar(): void {    
    const decodedBase64 = this._utils.base64Decode(this.data.ideRequest);                 
    const jsonObj = decodedBase64 ? JSON.parse(decodedBase64) : null;          
    delete jsonObj['codigo_error'];          
    const encodeBase64 = this._utils.utf8ToBase64(JSON.stringify(jsonObj));
    let ideRequest = encodeBase64;
    window.location.href = window.location.origin + `/WebIdentidadLogin?ideRequest=${ideRequest}&ideAccion=aGFiaWxpdGFy`
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/resources/components/notifications/notifications.component.ts